module.exports = __webpack_public_path__ + "static/img/chat_fr.e47b6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screens/chat_fr.png
// module id = 95
// module chunks = 0